import mondaySdk from 'monday-sdk-js'
import { utilService } from './utilService'
const monday = mondaySdk()
monday.setApiVersion("2025-04");
async function getMondayDetails(data: string, setMondayError: React.Dispatch<React.SetStateAction<boolean>>): Promise<number | DropDownOption[] | undefined> {
  try {
    const query: string = `query
  {
      account {
          id
      }
      boards(limit: 1500) {
          id
          name
      }
  }`

    const res: any = await monday.api(query)
    const boards: DropDownOption[] = utilService.convertToDropDownOptions(res.data.boards)
    const mondayAccountId: number = Number(res.data.account.id)
    if (data === 'boards') return boards
    else if (data === 'mondayAccountId') return mondayAccountId
    else return boards
  } catch (err) {
    console.log('file: mondayService.ts:9 -> err', err)
    setMondayError(true)
  }
}

async function getColumnsOptions(boardId: string, setBoardColumns: React.Dispatch<React.SetStateAction<any>>, setMondayError: React.Dispatch<React.SetStateAction<boolean>>): Promise<void | undefined> {
  try {
    const query: string = `query
    {
      boards(ids: ${Number(boardId)}) {
        columns {
          id
          type
          title
        }
      }
    }`
    const res: any = await monday.api(query)
    const columns = res.data.boards[0].columns
      .filter((column: any) => {
        return column.type !== 'subtasks'
      })
      .map((column: any) => {
        return {
          label: column.title === 'Name' ? 'Item name' : column.title,
          value: column.id,
          type: column.type,
        }
      })
    setBoardColumns(columns)
  } catch (err) {
    console.log('file: mondayService.ts:29 -> err', err)
    setMondayError(true)
  }
}

async function getColumnTitle(boardId: string, fieldName: string, fieldId: string, setMondayError: React.Dispatch<React.SetStateAction<boolean>>): Promise<DropDownOption | null | undefined> {
  try {
    const query: string = `query {
      boards(ids: ${Number(boardId)}) {
        name
        columns(ids: ${JSON.stringify(fieldId)}) {
          title
          type
        }
      }
    }`
    const res: any = await monday.api(query)

    if (fieldName === 'board') {
      const boardName: DropDownOption | null = res.data.boards[0]?.name
      return boardName || null
    } else {
      const columnTitle: DropDownOption | null = res.data.boards[0].columns[0]?.title === 'Name' ? 'Item name' : res.data.boards[0].columns[0]?.title
      return columnTitle || null
    }
  } catch (err) {
    console.log('file: mondayService.ts:55 -> err', err)
    setMondayError(true)
  }
}

async function getAccountInformation(setMondayError: React.Dispatch<React.SetStateAction<boolean>>): Promise<
  | {
      mondayDomain: string
      company: string
      userId: number
      userEmail: string
      userName: string
      mondayNumOfUsers: number
    }
  | undefined
> {
  try {
    const query: string = `{
      account {
        slug
        name
      }
      me {
        id
        email
        name
      }
      users{
        is_guest
      }
    }`
    const res: any = await monday.api(query)
    const mondayDomain = res.data.account.slug
    const company = res.data.account.name
    const userId = res.data.me.id
    const userEmail = res.data.me.email
    const userName = res.data.me.name
    const mondayNumOfUsers: number = res.data.users.filter((user: { is_guest: boolean }) => !user.is_guest)?.length

    return { mondayDomain, company, userId, userEmail, userName, mondayNumOfUsers }
  } catch (err) {
    console.log('file: mondayService.ts:83 -> err', err)
    setMondayError(true)
  }
}

async function getBoardDetails(boardId: number, setMondayError: React.Dispatch<React.SetStateAction<boolean>>): Promise<DropDownOption | undefined> {
  try {
    const query: string = `query
    {
        boards(ids: ${boardId}) {
            id
            name
        }
    }`

    const res: any = await monday.api(query)
    const board: DropDownOption = { label: res.data.boards[0].name, value: res.data.boards[0].id }

    return board
  } catch (err) {
    console.log('file: mondayService.ts:115 -> err', err)
    setMondayError(true)
  }
}

async function checkIfUserViewOnly(setMondayError: React.Dispatch<React.SetStateAction<boolean>>): Promise<boolean | undefined> {
  try {
    const query: string = `query {
      me{
        is_view_only
      }
    }
    `
    const res: any = await monday.api(query)
    return res.data.me.is_view_only
  } catch (err) {
    console.log('file: mondayService.ts:119 -> err', err)
    setMondayError(true)
  }
}

export const mondayService = {
  getMondayDetails,
  getColumnsOptions,
  getColumnTitle,
  getAccountInformation,
  getBoardDetails,
  checkIfUserViewOnly,
}
